import { css } from '@emotion/react'

export const paddedSpacing = ({ padded, size }) => theme => css`
  &&&&&& {
    padding: 4px 8px;
    margin-top: ${theme.spacing['0']};
    margin-right: ${theme.spacing['5']};
    margin-bottom: ${theme.spacing['0']};
    margin-left: calc(${theme.spacing['5']} * ${Number(padded)});
    min-height: ${size === 'large' ? '36px' : '30px'};
  }
`
